import { createContext } from 'react';

import { BuildingTypeColor } from '@totem/components/portfolio/buildings/list/buildingSummary/types';
import { Items } from '@totem/components/portfolio/buildings/list/squareFootage/types';

interface Context {
  loading: boolean;
  data: Items;
  colors: BuildingTypeColor[];
}

export default createContext<Context>({
  loading: false,
  data: null,
  colors: [],
});
